import cn from "classnames";
import React, { useCallback, useState, useMemo } from "react";

import { OrderItem } from "../../generated/graphql";

import styles from "./style.module.scss";

interface GalleryItemProps {
  image: string;
  index: number;
  isSelected: boolean;
  onClickImage: (index: number) => void;
}

const GalleryItem: React.FC<GalleryItemProps> = props => {
  const { image, index, isSelected, onClickImage } = props;

  const onClick = useCallback(() => {
    onClickImage(index);
  }, [onClickImage, index]);
  return (
    <div className={styles.imageWrapper} onClick={onClick}>
      <img
        src={image}
        alt="product-preview"
        className={cn(styles.imageItem, {
          [styles.selected]: isSelected,
        })}
      />
    </div>
  );
};

interface ProductDetailGalleryProps {
  item: OrderItem;
}

const ProductDetailGallery: React.FC<ProductDetailGalleryProps> = props => {
  const { item } = props;
  const [assetIndex, setAssetIndex] = useState<number>(0);

  const isReachLeftEnd = useMemo(() => {
    return assetIndex === 0;
  }, [assetIndex]);

  const isReachRightEnd = useMemo(() => {
    return assetIndex === item.images.length - 1;
  }, [assetIndex, item.images.length]);

  const onClickPrevious = useCallback(() => {
    if (isReachLeftEnd) return;

    setAssetIndex(pre => pre - 1);
  }, [isReachLeftEnd]);

  const onClickNext = useCallback(() => {
    if (isReachRightEnd) return;

    setAssetIndex(pre => pre + 1);
  }, [isReachRightEnd]);

  const onClickImage = useCallback((index: number) => {
    setAssetIndex(index);
  }, []);

  return (
    <div className={styles.imageGallery}>
      <div
        className={styles.imagePreview}
        style={{ backgroundImage: `url(${item.images[assetIndex]})` }}
      >
        <button
          className={cn(styles.galleryButton, styles.leftButton)}
          onClick={onClickPrevious}
          disabled={isReachLeftEnd}
        />
        <button
          className={cn(styles.galleryButton, styles.rightButton)}
          onClick={onClickNext}
          disabled={isReachRightEnd}
        />
      </div>
      <div className={styles.imageList}>
        {item.images.map((image, i) => (
          <GalleryItem
            key={i}
            image={image}
            index={i}
            isSelected={i === assetIndex}
            onClickImage={onClickImage}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductDetailGallery;
